import React, { useState } from 'react';
export function FloatingChat() {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="fixed right-6 bottom-24 z-40" data-id="element-92">
      {isOpen && <div className="bg-white rounded-lg shadow-lg p-4 mb-4 w-72 animate-fade-scale gradient-border" data-id="element-93">
          <div className="flex justify-between items-center mb-4" data-id="element-94">
            <h3 className="font-medium text-[#0F172A]" data-id="element-95">Need help?</h3>
            <button onClick={() => setIsOpen(false)} className="text-[#334155] hover:text-[#0F172A] transition-colors hover-rotate" data-id="element-96">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-97">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-98" />
              </svg>
            </button>
          </div>
          <div className="text-sm text-[#334155] mb-4 animate-typewriter" data-id="element-99">
            Have questions about iRelief Oculis-3? Our migraine specialists are
            here to help.
          </div>
          <button className="w-full bg-[#0EA5B7] hover:bg-[#0F172A] text-white font-medium py-2 px-4 rounded-md transition-all duration-300 text-sm btn-premium" data-id="element-100">
            Start Chat
          </button>
        </div>}
     
    </div>;
}